module.exports = __webpack_public_path__ + "img/t1_wing_nuts.prt.1314946a.jpg";